import PropTypes from "prop-types";

/**
 * PropTypes for ActivityLog component
 *
 * @property {Array} activities - Array of activity/audit log objects
 * @property {string|number} activities[].id - Activity ID
 * @property {string} activities[].documentId - Activity document ID
 * @property {string} activities[].category - Activity category (authentication, payment, etc.)
 * @property {string} activities[].eventType - Type of event
 * @property {string} activities[].severity - Severity level (INFO, WARN, CRITICAL)
 * @property {string} activities[].message - Activity message/description
 * @property {string} [activities[].ipAddress] - IP address of the activity origin
 * @property {string} activities[].createdAt - ISO timestamp of when activity occurred
 * @property {boolean} [isLoading=false] - Loading state indicator
 * @property {boolean} [showEmpty=true] - Show empty state message when no activities
 */
export const activityLogPropTypes = {
  activities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      documentId: PropTypes.string,
      category: PropTypes.string,
      eventType: PropTypes.string,
      severity: PropTypes.string,
      message: PropTypes.string,
      ipAddress: PropTypes.string,
      createdAt: PropTypes.string,
    })
  ),
  isLoading: PropTypes.bool,
  showEmpty: PropTypes.bool,
};
